import React, { Component, Fragment } from "react";
import ReactGA from "react-ga";
import { Helmet } from "react-helmet";
// import Link from 'react-router-dom/Link';
import NavTop from "../../containers/NavTop/NavTop";
import { Timeline } from "react-twitter-widgets";
import { Row, Col, Anchor, BackTop, List, Icon, Divider } from "antd";
import "./UpdatesPage.css";
import UpdateCard from "../../common/Cards/UpdateCard/UpdateCard";
import UpdatesHeader from "../../containers/UpdatesHeader/UpdatesHeader";
import jsondata from "../../common/Cards/UpdateCard/data_update.json";

class UpdatesPage extends Component {
  constructor(props) {
    super(props);
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  componentWillMount() {
    let { pageOn } = this.props;
    console.log(pageOn);
  }

  render() {
    return (
      <Fragment>
        <Helmet>
          <meta charSet="utf-8" />
          <title>RealTimeTouch.com - Updates</title>
          <link rel="canonical" href="http://www.realtimetouch.com/updates/" />
        </Helmet>
        <NavTop pageOn={this.props.pageOn} />
        <BackTop />
        <UpdatesHeader />
        <div className="center">
          <div className="UpdatesPage--headline-container">
            <h2 className="UpdatesPage--headline" id="Press-Releases">
              Updates, News & Press Releases
            </h2>
            <h4 className="UpdatesPage--subheadline">
              The latest updates and on Real Time Touch technology
            </h4>
            <p className="UpdatesPage--body center">
              Real Time Touch is active in social media, in press releases and
              is available for media comment. With extensive experience in
              telemedicine technology inventions and design we are active
              members in the health technology community. See our social media
              posts and press releases below
            </p>
          </div>
          <div className="UpdatesPage--container-headlines">
            <Row>
              <Col sm={24} md={12}>
                <br />
                <h3>Press Releases</h3>
                <List
                  itemLayout="horizontal"
                  dataSource={jsondata}
                  renderItem={item => {
                    var item_id = `#${item.id}`;
                    return (
                      <Anchor affix={false} offsetTop="70">
                        <Anchor.Link
                          href={item_id}
                          title={
                            <Row>
                              <Col md={2}>
                                <Icon
                                  className="UpdatesPage--container-headline-icon"
                                  type="right-circle"
                                />
                              </Col>
                              <Col md={22}>
                                <List.Item>
                                  <List.Item.Meta
                                    title={item.title}
                                    description={item.subheadline}
                                  />
                                </List.Item>
                              </Col>
                            </Row>
                          }
                        />
                      </Anchor>
                    );
                  }}
                />
              </Col>

              <Col id="Twitter" sm={24} md={12}>
                <Timeline
                  dataSource={{
                    sourceType: "profile",
                    screenName: "realtimetouch"
                  }}
                  options={{
                    username: "RealTimeTouch",
                    height: "800",
                    width: "600"
                  }}
                  onLoad={() => console.log("Timeline is loaded!")}
                />
              </Col>
            </Row>

            <Row>
              <Col span={24} style={{ textAlign: "center" }}>
                <Divider />

                <h2 id="Social-Media">Real Time Touch Social Media</h2>
                <p id="Social-Media-click">(Click boxes below to view social media feeds)</p>
                <a href="https://www.facebook.com/realtimetouch/">
                  <Icon type="facebook" className="fa fa-facebook" />
                </a>
                <a href="https://twitter.com/realtimetouch/">
                  <Icon type="twitter" className="fa fa-twitter" />
                </a>
                <a href="">
                  <Icon type="google" className="fa fa-google" />
                </a>
                <a href="https://www.linkedin.com/company/realtimetouch/">
                  <Icon type="linkedin" className="fa fa-linkedin" />
                </a>
                <a href="https://www.realtimetouch.com/videos">
                  <Icon type="youtube" className="fa fa-youtube" />
                </a>
              </Col>
            </Row>
            <br />
          </div>
        </div>
        <div className="UpdatesPage--container-headlines-inner">
          <div className="UpdatesPage--container-articles">
            <Divider />

            <h2 style={{ textAlign: "center" }}>
              {" "}
              Real Time Touch Press Releases
            </h2>
            <p style={{ textAlign: "center" }}>
              {" "}
              From newest to oldest. These include archived press releases from circa ~2000s
            </p>

            <UpdateCard pick="RTT-Mirror-Review" />
            <Divider />           
            <UpdateCard pick="Real-Time-Touch-Profiled-Business-Connect" />
            <Divider />            
            <UpdateCard pick="Helping-Healthcare-At-Home-And-Field" />
            <Divider />
            <UpdateCard pick="Telehealth-Pioneer-Craig-Linden-Awarded-Top-100-Healthcare-Leaders-Award" />
            <Divider />
            <UpdateCard pick="RemoteRx-Telemedicine-Dispenser-Platform-by-Real-Time-Touch" />
            <Divider />
            <UpdateCard pick="Inventor-Reboot-Industry" />
            <Divider />
            <UpdateCard pick="Craig-Linden-on-Amazon-PillPack" />
            <Divider />
            <UpdateCard pick="Craig-Linden-ATA18" />
            <Divider />
            <UpdateCard pick="Design-Systems-RD-Warns" />
            <Divider />
            <UpdateCard pick="Interactive-Toys-Transfer-Live-Human-Touch" />
            <Divider />
            <UpdateCard pick="Wireless-Physical-Touch-Adds-Fun-and-Purpose" />
            <Divider />
            <UpdateCard pick="eBooks-with-Sensory-Touch" />
            <Divider />
            <UpdateCard pick="Nokia-Applies-Interactive-Feel-To-Wireless-Phone-Games" />
            <Divider />
            <UpdateCard pick="Physical-Touch-Technology-Adds-Dimension-to-Communications" />
          </div>
        </div>
      </Fragment>
    );
  }
}

export default UpdatesPage;



// WEBPACK FOOTER //
// ./src/pages/UpdatesPage/UpdatesPage.js